import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Sparkles, Flame, BookOpen, Users, Target, Crown, LogOut } from "lucide-react";

const items = [
  { to: "/app",           icon: Sparkles, label: "Today",     end: true, id: "today" },
  { to: "/app/habits",    icon: Flame,    label: "Habits",    id: "habits" },
  { to: "/app/journal",   icon: BookOpen, label: "Journal",   id: "journal" },
  { to: "/app/community", icon: Users,    label: "Community", id: "community" },
  { to: "/app/challenges",icon: Target,   label: "Challenges",id: "challenges" },
];

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => { await logout(); navigate("/", { replace: true }); };

  return (
    <div className="min-h-screen">
      {/* Desktop sticky top nav */}
      <header className="glass-nav sticky top-0 z-30 hidden md:block" data-testid="app-header">
        <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <NavLink to="/app" className="flex items-center gap-2" data-testid="brand-home">
              <div className="w-8 h-8 rounded-full bg-[#E07A5F] flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" strokeWidth={2.5} />
              </div>
              <span className="font-display font-semibold text-lg">Bloom</span>
            </NavLink>
            <nav className="flex items-center gap-1">
              {items.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  end={it.end}
                  data-testid={`nav-${it.id}`}
                  className={({ isActive }) =>
                    `pill-btn text-sm ${isActive ? "bg-[#2D3142] text-white" : "text-[#2D3142] hover:bg-white"}`
                  }
                >
                  {it.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            {!user?.is_premium && (
              <NavLink to="/app/premium" className="pill-btn text-sm bg-[#F2CC8F]/60 text-[#8A5A2B] hover:bg-[#F2CC8F]" data-testid="nav-premium">
                <Crown className="w-4 h-4 inline mr-1" /> Premium
              </NavLink>
            )}
            {user?.is_premium && (
              <span className="tag-chip bg-[#2D3142] text-[#F2CC8F]"><Crown className="w-3 h-3" /> Premium</span>
            )}
            <div className="flex items-center gap-2 pl-3 border-l border-[#E5E3DF]">
              <img src={user?.picture || `https://api.dicebear.com/7.x/thumbs/svg?seed=${user?.email}`} alt="" className="w-8 h-8 rounded-full object-cover" data-testid="user-avatar" />
              <button onClick={handleLogout} className="p-2 text-[#8A8D98] hover:text-[#E07A5F]" data-testid="logout-btn"><LogOut className="w-4 h-4" /></button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 md:px-6 py-6 md:py-10 pb-24 md:pb-10">
        <Outlet />
      </main>

      {/* Mobile bottom nav */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 glass-nav" data-testid="mobile-nav">
        <div className="grid grid-cols-5">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`mnav-${it.id}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-3 text-[10px] uppercase tracking-widest ${isActive ? "text-[#E07A5F]" : "text-[#8A8D98]"}`
              }
            >
              <it.icon className="w-5 h-5" />
              {it.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
